<md-popup-offcanvas
    #searchOccupancyOffcanvas
    [mobileContinueButtonText]="'Search' | translate"
    [mobileContinueButtonClick]="onModalContinueClick"
    [mobileContinueButtonDisabled]="invalidChildAges()"
    [mobileSecondaryButtonText]="'Clear all' | translate"
    [mobileSecondaryButtonClick]="resetToTwoAdults"
    [mobileSecondaryButtonVisible]="true"
    [darkBackgroundOnOpen]="darkBackgroundOnOpen"
>
    <div actualControl select="[actualControl]" class="c-o-container">
        <div class="c-o-counter">
            <div class="c-o-text">
                <div class="c-o-text-name">
                    {{ "AgeGroup.Adults" | translate }}
                </div>
                <div class="c-o-text-description">
                    {{ "Age" | translate }} 18+
                </div>
            </div>
            <md-counter
                [counterValue]="nrOfAdults"
                [minValue]="1"
                [maxValue]="canAddAdults ? 30 : nrOfAdults"
                (valueChanged)="onAdultNrChanged($event)"
            ></md-counter>
        </div>
        <div class="c-o-separator"></div>
        <div class="c-o-counter">
            <div class="c-o-text">
                <div class="c-o-text-name">{{ "Children" | translate }}</div>
                <div *ngIf="showChildAgeLabel" class="c-o-text-description">
                    {{ "Age" | translate }} 0-17
                </div>
            </div>
            <md-counter
                [counterValue]="nrOfChildren"
                [maxValue]="canAddChildren ? 30 : nrOfChildren"
                (valueChanged)="onChildNrChanged($event)"
            ></md-counter>
        </div>
        <div *ngIf="nrOfChildren > 0">
            <p class="c-o-text-age-title">
                {{ "Age of children at check-out" | translate }}
            </p>
            <p *ngIf="!internalOccupancyLimits" class="c-o-text-age-sub">
                {{
                    "Add the age for each child to get the best match in"
                        | translate
                }}
                <br />{{ "beds, room size, and special prices." | translate }}
            </p>
            <p *ngIf="internalOccupancyLimits" class="c-o-text-age-sub">
                <span>{{ "Age groups for this stay:" | translate }}</span>
                <ng-container
                    *ngFor="let ageGroup of internalOccupancyLimits.ageGroups"
                >
                    <br />
                    <span
                        >{{ ageGroup.ageGroupType }}({{ ageGroup.ageFrom }} -
                        {{ ageGroup.ageTo }})</span
                    >
                </ng-container>
            </p>
            <div
                class="c-o-age-item"
                *ngFor="let child of childrenAges; let i = index"
            >
                <p>
                    {{ "Child" | translate }} {{ i + 1
                    }}<span class="c-o-error"> *</span>
                </p>
                <div class="c-o-custom-select">
                    <select
                        [ngClass]="{
                            'c-o-error': childrenAges[i] === -1
                        }"
                        [(ngModel)]="childrenAges[i]"
                        (mousedown)="selectClicked(i)"
                        (change)="ageSelected($event.target.value, i)"
                    >
                        <option value="-1" disabled selected>
                            {{ "Child age required" | translate }}
                        </option>
                        <option
                            *ngFor="let ageOption of childAgeOptions[i]"
                            value="{{ ageOption }}"
                        >
                            {{ ageOption }} {{ "Years old" | translate }}
                        </option>
                    </select>
                    <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
            </div>
        </div>
        <div class="c-o-button-apply" *ngIf="!hasRenderedAsMobile">
            <button
                [disabled]="invalidChildAges()"
                mdMainButton="light"
                (click)="applyOccupancy()"
            >
                {{ (showChildAgeLabel ? "Search" : "Apply") | translate }}
            </button>
        </div>
    </div>
    <ng-content targetControl select="[targetControl]"></ng-content>
</md-popup-offcanvas>
